(function () {
  var GAP = 8;
  var VIEWPORT_GAP = 16;
  var DEFAULT_TOP = 225;
  var COMPACT_TAB_HEIGHT = 108;
  var DEFAULT_TAB_HEIGHT = 120;
  var TAB_CLASS = 'oke-reviewsTab';
  var BANNER_CLASS = 'sfs-banner';
  var HERO_CLASS = 'shopify-section-hero-banner';
  var FREE_SHIP_MEDIA = 'img[src*="free-shipping"], source[srcset*="free-shipping"]';
  var OBSERVED_ATTRIBUTES = ['hidden', 'aria-hidden', 'class', 'style', 'src', 'srcset'];
  var media = window.matchMedia('(min-width: 750px)');
  var placementFrame = null;
  var lastTop = null;
  var lastTab = null;
  var managedStyleWrites = [];

  function isElement(node) {
    return Boolean(node && node.nodeType === 1);
  }

  function hasClass(node, className) {
    return isElement(node) && node.classList.contains(className);
  }

  function closestClass(node, className) {
    var current = isElement(node) ? node : null;
    while (current) {
      if (hasClass(current, className)) return current;
      current = current.parentElement;
    }
    return null;
  }

  function containsClass(node, className) {
    if (!isElement(node)) return false;
    if (hasClass(node, className)) return true;
    return Boolean(node.querySelector('.' + className));
  }

  function isFreeShipMedia(node, previousValue) {
    if (!isElement(node)) return false;
    var tag = String(node.tagName || '').toLowerCase();
    var attribute = tag === 'img' ? 'src' : tag === 'source' ? 'srcset' : '';
    if (!attribute) return false;
    var value = node.getAttribute(attribute) || '';
    return (
      value.indexOf('free-shipping') !== -1 ||
      String(previousValue || '').indexOf('free-shipping') !== -1
    );
  }

  function containsFreeShipMedia(node) {
    if (!isElement(node)) return false;
    if (isFreeShipMedia(node)) return true;
    return Boolean(node.querySelector(FREE_SHIP_MEDIA));
  }

  function isFreeShipHero(node) {
    return hasClass(node, HERO_CLASS) && containsFreeShipMedia(node);
  }

  function containsFreeShipHero(node) {
    if (!isElement(node)) return false;
    if (isFreeShipHero(node)) return true;
    var heroes = node.querySelectorAll('.' + HERO_CLASS);
    for (var i = 0; i < heroes.length; i++) {
      if (isFreeShipHero(heroes[i])) return true;
    }
    return false;
  }

  function nodesContain(nodes, predicate) {
    for (var i = 0; i < nodes.length; i++) {
      if (predicate(nodes[i])) return true;
    }
    return false;
  }

  function nodeTouchesTrackedSurface(node) {
    return (
      containsClass(node, TAB_CLASS) ||
      containsClass(node, BANNER_CLASS) ||
      containsFreeShipHero(node)
    );
  }

  function childMutationIsRelevant(record) {
    if (closestClass(record.target, TAB_CLASS) || closestClass(record.target, BANNER_CLASS)) {
      return true;
    }

    var hero = closestClass(record.target, HERO_CLASS);
    if (
      hero &&
      (isFreeShipHero(hero) ||
        nodesContain(record.addedNodes, containsFreeShipMedia) ||
        nodesContain(record.removedNodes, containsFreeShipMedia))
    ) {
      return true;
    }

    return (
      nodesContain(record.addedNodes, nodeTouchesTrackedSurface) ||
      nodesContain(record.removedNodes, nodeTouchesTrackedSurface)
    );
  }

  function oldClassIncludes(record, className) {
    var classes = ' ' + (record.oldValue || '') + ' ';
    return classes.indexOf(' ' + className + ' ') !== -1;
  }

  function setManagedStyle(target, propertyName, value, priority) {
    var oldValue = target.getAttribute('style');
    target.style.setProperty(propertyName, value, priority || '');
    managedStyleWrites.push({
      target: target,
      oldValue: oldValue,
      newValue: target.getAttribute('style'),
    });
  }

  function isManagedPlacementStyle(record) {
    if (record.attributeName !== 'style') return false;
    for (var i = 0; i < managedStyleWrites.length; i++) {
      var write = managedStyleWrites[i];
      if (write.target !== record.target || write.oldValue !== record.oldValue) continue;
      managedStyleWrites.splice(i, 1);
      return write.newValue === record.target.getAttribute('style');
    }
    return false;
  }

  function recordHadFreeShipMedia(record) {
    if (record.type !== 'attributes') return false;
    var tag = String(record.target.tagName || '').toLowerCase();
    var isMediaAttribute =
      (tag === 'img' && record.attributeName === 'src') ||
      (tag === 'source' && record.attributeName === 'srcset');
    return isMediaAttribute && String(record.oldValue || '').indexOf('free-shipping') !== -1;
  }

  function childRecordRemovedFreeShipMedia(record, hero) {
    if (record.type !== 'childList') return false;
    if (record.target !== hero && !hero.contains(record.target)) return false;
    return nodesContain(record.removedNodes, containsFreeShipMedia);
  }

  function batchRemovesFreeShipHero(records) {
    for (var i = 0; i < records.length; i++) {
      var classRecord = records[i];
      if (
        classRecord.type !== 'attributes' ||
        classRecord.attributeName !== 'class' ||
        !oldClassIncludes(classRecord, HERO_CLASS)
      ) {
        continue;
      }
      if (containsFreeShipMedia(classRecord.target)) return true;
      for (var j = 0; j < records.length; j++) {
        var identityRecord = records[j];
        if (
          (recordHadFreeShipMedia(identityRecord) &&
            classRecord.target.contains(identityRecord.target)) ||
          childRecordRemovedFreeShipMedia(identityRecord, classRecord.target)
        ) {
          return true;
        }
      }
    }
    return false;
  }

  function targetTouchesTrackedSurface(record) {
    var target = record.target;
    if (
      closestClass(target, TAB_CLASS) ||
      closestClass(target, BANNER_CLASS) ||
      nodeTouchesTrackedSurface(target)
    ) {
      return true;
    }

    var hero = closestClass(target, HERO_CLASS);
    if (hero && isFreeShipHero(hero)) return true;

    return (
      record.attributeName === 'class' &&
      (oldClassIncludes(record, TAB_CLASS) ||
        oldClassIncludes(record, BANNER_CLASS) ||
        (oldClassIncludes(record, HERO_CLASS) && containsFreeShipMedia(target)))
    );
  }

  function attributeMutationIsRelevant(record) {
    if (isManagedPlacementStyle(record)) return false;
    if (record.attributeName === 'src' || record.attributeName === 'srcset') {
      var hero = closestClass(record.target, HERO_CLASS);
      if (!hero) return false;
      return isFreeShipHero(hero) || isFreeShipMedia(record.target, record.oldValue);
    }
    return targetTouchesTrackedSurface(record);
  }

  function mutationsAreRelevant(records) {
    if (batchRemovesFreeShipHero(records)) return true;
    for (var i = 0; i < records.length; i++) {
      var record = records[i];
      if (record.type === 'childList' && childMutationIsRelevant(record)) return true;
      if (record.type === 'attributes' && attributeMutationIsRelevant(record)) return true;
    }
    return false;
  }

  function visibleFreeShip() {
    var list = document.querySelectorAll('.sfs-banner, .shopify-section-hero-banner');
    for (var i = 0; i < list.length; i++) {
      var el = list[i];
      if (el.classList.contains('shopify-section-hero-banner')) {
        if (
          !el.querySelector('img[src*="free-shipping"]') &&
          !el.querySelector('source[srcset*="free-shipping"]')
        ) {
          continue;
        }
      }
      var cs = window.getComputedStyle(el);
      if (cs.display === 'none' || cs.visibility === 'hidden') continue;
      if (el.getBoundingClientRect().height < 8) continue;
      return el;
    }
    return null;
  }

  function visibleTabRect(tab) {
    if (tab.hidden || tab.getAttribute('aria-hidden') === 'true') return null;
    var cs = window.getComputedStyle(tab);
    if (cs.display === 'none' || cs.visibility === 'hidden') return null;
    if (!tab.getClientRects().length) return null;
    var rect = tab.getBoundingClientRect();
    if (rect.width <= 0 || rect.height <= 0) return null;
    return rect;
  }

  function tabHeight(rect) {
    var measuredHeight = rect.height;
    if (measuredHeight >= 8) return measuredHeight;
    return window.innerWidth < 1200 ? COMPACT_TAB_HEIGHT : DEFAULT_TAB_HEIGHT;
  }

  function clamp(value, minimum, maximum) {
    return Math.min(Math.max(value, minimum), Math.max(minimum, maximum));
  }

  function place() {
    if (document.documentElement.classList.contains('sb-mobile-or-ipad')) return;
    if (!media.matches) return;
    var tab = document.querySelector('.oke-reviewsTab');
    if (!tab) {
      lastTab = null;
      return;
    }
    var tabRect = visibleTabRect(tab);
    if (!tabRect) {
      lastTab = null;
      return;
    }
    var banner = visibleFreeShip();
    var viewportHeight = Math.max(0, Number(window.innerHeight) || 0);
    var top = DEFAULT_TOP;
    if (banner) {
      var bannerBottom = Math.round(banner.getBoundingClientRect().bottom);
      if (bannerBottom >= VIEWPORT_GAP && bannerBottom < viewportHeight) {
        top = bannerBottom + GAP;
      }
    }
    var maximumTop = viewportHeight - tabHeight(tabRect) - VIEWPORT_GAP;
    top = Math.round(clamp(top, VIEWPORT_GAP, maximumTop));
    var pixelTop = top + 'px';
    var bodyTopMatches =
      document.body.style.getPropertyValue('--sb-oke-tab-top') === pixelTop;
    var tabTopMatches =
      tab.style.getPropertyValue('top') === pixelTop &&
      tab.style.getPropertyPriority('top') === 'important';
    if (pixelTop === lastTop && tab === lastTab && bodyTopMatches && tabTopMatches) return;
    lastTop = pixelTop;
    if (!bodyTopMatches) {
      setManagedStyle(document.body, '--sb-oke-tab-top', pixelTop);
    }
    if (!tabTopMatches || tab !== lastTab) {
      setManagedStyle(tab, 'top', pixelTop, 'important');
    }
    lastTab = tab;
  }

  function schedulePlace() {
    if (placementFrame !== null) return;
    placementFrame = window.requestAnimationFrame(function () {
      placementFrame = null;
      place();
    });
  }

  function ensureStyle() {
    if (document.getElementById('sb-oke-tab-place')) return;
    var s = document.createElement('style');
    s.id = 'sb-oke-tab-place';
    s.textContent =
      '@media (min-width: 750px){body#themeBody .oke-reviewsTab{top:var(--sb-oke-tab-top, 225px) !important}}';
    (document.head || document.documentElement).appendChild(s);
  }

  function start() {
    ensureStyle();
    schedulePlace();
    window.addEventListener('resize', schedulePlace);
    if (!document.body) return;
    var obs = new MutationObserver(function (records) {
      if (mutationsAreRelevant(records)) schedulePlace();
    });
    obs.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeOldValue: true,
      attributeFilter: OBSERVED_ATTRIBUTES,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
